import { Component, ElementRef, Input, Output} from '@angular/core';
import { Http} from "@angular/http";
import { FileUploader, FileItem} from 'ng2-file-upload';
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import { ApplicationUser } from './../../../services/ApplicationUser';
import {UsersService} from "../../../models/users/users.service";
import {NewLeadModel} from "../../../models/leads/leads.model";
import {StaticDataService} from "../../../services/StaticData.service";
import {LeadsStatusType} from "../../../models/leads/leads.type";
import {ProvincesModel} from "../../../models/provinces/provinces.model";
import {ProvincesService} from "../../../models/provinces/provinces.service";
import {ValidationService} from "../../../services/validation.service";
import {ClientsService} from "../../../models/clients/clients.service";
import {AuthErrorEventer} from '../../../app.helpers';
import {phoneFormatter} from "../../../helpers/phone-format";

import {SlackApi} from "../../../components/slack-api/slack-api.component";

@Component({
    selector: 'lead-import-quick',
    templateUrl: 'quick.html',
    styleUrls: ['lead-import.component.css']
})
export class LeadImportQuickComponent{
    phoneFormatter = phoneFormatter;
    @Input() onChangeState: (state: any) => {};

    private _state = 'none';
    private _setState(state) {
        this._state = state;
        if (this.onChangeState) this.onChangeState(state);
    }

    public uploader:FileUploader;
    public hasBaseDropZoneOver:boolean = false;
    public messageText: string = '';
    public errors: Array<any> = [];

    public openerList: Array<any> = [];
    public isCheckedAll: boolean = false;
    public checkedList: any = {opener:[]};
    public Users: UsersService;

    public lead = new NewLeadModel();
    public industries: Array<any>;
    public provinces: Array<any>;
    public $leadForm;
    public fundingSpecialist: Array<any>;

    salesNote: any = '';

    public slackUsers: Array<any> = [];

    // ===========================================================
    // Init
    // ===========================================================

    constructor(private http: Http,
                private toasterService: ToasterService,
                private provincesService: ProvincesService,
                private validationService: ValidationService,
                private clientsService: ClientsService,
                private usersService: UsersService,
                private slackApi: SlackApi,
                protected el: ElementRef){

        AuthErrorEventer.getIt().event = () => {
            this._setState('none');
        };

        this.Users = new UsersService(this.http);

        let user = ApplicationUser.getInstance();
        this.uploader = new FileUploader({
            url: '/api/v1/leads/import',
            headers: [{name: 'Authorization',value: user.getAccessToken()}],
            queueLimit: 2,
            isHTML5: true,
            itemAlias: 'importFile',
            additionalParameter: {
                opener: []
            }
        });

        this.uploader.onSuccessItem = (item: FileItem, response: string) => {

            let resData = JSON.parse(response);

            this.messageText = resData.data.result;
            this.errors = resData.data.errors;
        };

        this.uploader.onErrorItem = (item, response) => {
            let resp = JSON.parse(response);
            this.toasterService.pop('error', 'Error', resp.errors.importFile[0]);
        };

        this.uploader.onAfterAddingFile = () => {
            if(this.uploader.queue[1]){
                this.uploader.removeFromQueue(this.uploader.queue[0]);
            }
            this.messageText = '';
        };

        this.uploader.onBeforeUploadItem = () => {
            this.uploader.setOptions({additionalParameter: {
                opener: this.checkedList.opener
            }});
        };
    }

    ngOnInit() {
        this.loadOpenerList();
        this.loadUserFSList();
        this.industries = StaticDataService.getInstance().getData();

        this.provincesService.getList()
            .subscribe((res) => {
                this.provinces = res.data;
            });

        this.getSlackUsers();
    }

    ngAfterViewInit() {
        this.$leadForm = $('form[name="lead-form"]', this.el.nativeElement);
        this.$leadForm.validate({
            focusCleanup: true
        });
    }


    // ===========================================================
    // Load Data
    // ===========================================================

    private loadOpenerList() {
        this.Users.getOpener()
            .subscribe(
                (res) => {
                    this.openerList = res.data;

                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });

    }

    private loadUserFSList() {

        this.usersService.getFS()
            .subscribe(
                (res) => {
                    this.fundingSpecialist = res.data;
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                });
    }



    // ===========================================================
    // Actions
    // ===========================================================

    public selectAll() {
        let newOpener = [];
        if(this.isCheckedAll){
            this.openerList.map(function(item){
                newOpener.push(item.id.toString());
            });
        }
        this.checkedList.opener = newOpener;
    }

    public changeOpener() {
        if(this.isCheckedAll){
            this.isCheckedAll = false;
        }
    }

    public quickAdd() {
        if (this._state == 'loading') return;
        this._setState('loading');
        this.clientsService.quickAdd(this.lead, this.salesNote)
            .subscribe((res) => {
                this.lead = new NewLeadModel();
                this.salesNote = '';
                this.toasterService.pop('success', 'Success', 'Lead is added');
                this._setState('ok');
            }, (err) => {
                this.validationService.showError(err, this.$leadForm);
                this._setState('error');
            });
    }


    // ===========================================================
    // Functions
    // ===========================================================

    public fileOverBase(e:any):void {
        this.hasBaseDropZoneOver = e;
    }


    public getSlackUsers() {
        this.slackApi.getMentions()
            .subscribe((res) => {
                this.slackUsers = res.data.filter(x => x);
            });
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/import/quick.component.ts